import { ANSWER_SOURCE, DOC_TYPES, getDisplayableQuestions, TEDCApplicant, useEDCFlow } from "@smvtech/x-flux";
import { useMemo } from "react";
import QuestionItem from "./QuestionItem";

type QuestionsListProps = {
	activeApplicantData: TEDCApplicant;
};

const QuestionsList = ({ activeApplicantData }: QuestionsListProps) => {
	const { order } = useEDCFlow();
	const questions = useMemo(
		() => getDisplayableQuestions(activeApplicantData.questions, [ANSWER_SOURCE.PASSPORT_FRONT_OCR]),
		[activeApplicantData.questions]
	);

	const isPassportFrontAndUploaded = (() => {
		const hasPassportFrontQuestion = activeApplicantData.questions.some(
			(q) => q.question.doc_type === DOC_TYPES.PASSPORT_FRONT
		);

		if (!hasPassportFrontQuestion) {
			return true;
		}

		return activeApplicantData.questions.some((q) => {
			return (
				q.question.doc_type === DOC_TYPES.PASSPORT_FRONT &&
				!!q.answer_data?.assets_id?.find((asset) => asset.status === "APPROVED")
			);
		});
	})();

	const tooltip = !isPassportFrontAndUploaded ? "Please upload Passport Front to start answering" : undefined;
	const disabled = !isPassportFrontAndUploaded || !!order?.qc_terms_and_conditions;
	return (
		<div className="col-span-2 flex w-full flex-col gap-6">
			{questions.map((question) => (
				<QuestionItem
					key={`${activeApplicantData.application_id}-${question.id}-${question.answer_data?.answer?.[0] ?? ""}`}
					question={question}
					applicationId={activeApplicantData.application_id}
					travellerId={activeApplicantData.traveller._id}
					disabled={disabled}
					tooltip={tooltip}
				/>
			))}
		</div>
	);
};

export default QuestionsList;

